export const checkIfAllCaps = (str: string): boolean => str === str.toUpperCase();

export const formatToProperCaseType = (title: string): string => {
  return checkIfAllCaps(title) ? title : title.toLowerCase();
};
